export default function () {
  return {
    banks: [],
    banksLoaded: false,
    banksLoading: false
  }
}
